import { useState, useEffect } from "react";
import "./MediaGallery.css";
import { Asset, iconPath } from "effno-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";

type MediaGalleryProps = {
    assets: Asset[] | undefined
    noSelect: boolean;
    onSelectedAsset: (asset: Asset) => void;
    onDeleteAsset: (asset: Asset) => void;
}

export const MediaGallery = ({assets, noSelect, onSelectedAsset, onDeleteAsset} : MediaGalleryProps) => {

    const storeUser = useSelector(selectUser);
    
    return (
        <div className="media-gallery">
            {assets && assets.map((asset: Asset) => {
                return (
                    <div 
                        className="media-gallery-asset"
                        onClick={()=>{
                            if (!noSelect) {
                                onSelectedAsset(asset)
                            }
                        }}
                        style={noSelect ? {cursor: "default"} : {}}
                    >
                        <img src={asset.URL} />
                        <div 
                            className="media-gallery-asset-delete"
                            onClick={() => {
                                onDeleteAsset(asset);
                            }}
                        >
                            <img src={iconPath("delete.svg", storeUser)} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}